import { DepositsApiBase } from '@/api/paymentApi';

class DepositApi extends DepositsApiBase {

}
export default new DepositApi();